module.exports = __webpack_public_path__ + "img/identityChecked4.cdf47c42.png";